import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from '~/hooks/useAuth';
import { Login } from '~/components/Login';
import { AuthCallback } from '~/components/AuthCallback';
import { ProtectedRoute } from '~/components/ProtectedRoute';
import { Layout } from '~/components/Layout';
import { Dashboard } from '~/components/Dashboard';
import { ConversionFunnel } from '~/components/ConversionFunnel';
import { FormsList } from '~/components/FormsList';
import { FormDetail } from '~/components/FormDetail';
import { FormLogs } from '~/components/FormLogs';
import { FormEditorNew } from '~/components/FormEditorNew';
import { IntegrationSettings } from '~/components/IntegrationSettings';
import { HubSpotOAuthCallback } from '~/components/HubSpotOAuthCallback';
import { AttioOAuthCallback } from '~/components/AttioOAuthCallback';
import { SlackOAuthCallback } from '~/components/SlackOAuthCallback';

export const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/funnel" element={<ConversionFunnel />} />
              <Route path="/forms" element={<FormsList />} />
              <Route path="/forms/new" element={<FormEditorNew />} />
              <Route path="/forms/:id" element={<FormDetail />} />
              <Route path="/forms/:id/logs" element={<FormLogs />} />
              <Route path="/forms/:id/edit" element={<FormEditorNew />} />
              <Route path="/integrations" element={<IntegrationSettings />} />
              <Route path="/integrations/hubspot/callback" element={<HubSpotOAuthCallback />} />
              <Route path="/integrations/attio/callback" element={<AttioOAuthCallback />} />
              <Route path="/integrations/slack/callback" element={<SlackOAuthCallback />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};
